import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { Footer } from './Footer.js';

const FooterContainer = ({ readOnly , policyItems , unavailableLineItems  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Footer, {
        summaryLabel: getLabel('cart.discount.summary'),
        formTitleLabel: getLabel('cart.discountForm.title'),
        readOnly: readOnly,
        policyItems: policyItems,
        unavailableLineItems: unavailableLineItems
    });
};

export { FooterContainer };
//# sourceMappingURL=FooterContainer.js.map
